<label class="switch">
    <input type="checkbox" id="toggle-labelled-{{ id }}" [disabled]="disable" [(ngModel)]="value" />
    <div class="toggle-mark">
        <span class="label-1" [translate]="label1"></span>
        <span class="label-2" [translate]="label2"></span>
    </div>
</label>
